import { render, staticRenderFns } from "./PurchaseOrderCompletionReportView.vue?vue&type=template&id=0324baf0"
import script from "./PurchaseOrderCompletionReportView.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderCompletionReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports